export default __webpack_public_path__ + "static/Agile-Book-6bcb8750aad9e3865a194a5ec6d2bf8b.ttf";